import {
  fetchLocationsList,
  fetchItemTypesList,
  fetchItemsByParticipant,
  scanParticipant as scanParticipantApi,
  scanParticipantByFacial as scanParticipantByFacialApi,
  storeItem,
  returnItem,
  fetchStats
} from '@/modules/storage/service/storageService'

export const STORAGE_MODULE = 'STORAGE'

export default {
  state: {
    locations: [],
    itemTypes: [],
    currentParticipant: null,
    currentItems: [],
    stats: null,
    locationsLoaded: false,
    itemTypesLoaded: false
  },
  actions: {
    async loadLocations ({ state, commit }) {
      if (state.locationsLoaded) {
        return state.locations
      }
      try {
        const response = await fetchLocationsList()
        var locations = response.data || response
        commit('setLocations', locations)
        return locations
      } catch (error) {
        console.error('Erro ao carregar localizações:', error)
        throw error
      }
    },
    async reloadLocations ({ commit }) {
      try {
        const response = await fetchLocationsList()
        var locations = response.data || response
        commit('setLocations', locations)
        return locations
      } catch (error) {
        console.error('Erro ao recarregar localizações:', error)
      }
    },
    async loadItemTypes ({ state, commit }) {
      if (state.itemTypesLoaded) {
        return state.itemTypes
      }
      try {
        const response = await fetchItemTypesList()
        var itemTypes = response.data || response
        commit('setItemTypes', itemTypes)
        return itemTypes
      } catch (error) {
        console.error('Erro ao carregar tipos de item:', error)
        throw error
      }
    },
    async scanParticipant ({ commit }, qrcode) {
      try {
        const result = await scanParticipantApi(qrcode)
        commit('setCurrentParticipant', result.participant)
        commit('setCurrentItems', result.items.data || result.items)
        return result
      } catch (error) {
        console.error('Erro ao escanear participante:', error)
        throw error
      }
    },
    async scanParticipantByFacial ({ commit }, photo) {
      try {
        const result = await scanParticipantByFacialApi(photo)
        commit('setCurrentParticipant', result.participant)
        commit('setCurrentItems', result.items.data || result.items)
        return result
      } catch (error) {
        console.error('Erro ao identificar participante por facial:', error)
        throw error
      }
    },
    async loadParticipantItems ({ commit }, participantId) {
      try {
        const items = await fetchItemsByParticipant(participantId)
        commit('setCurrentItems', items.data || items)
        return items
      } catch (error) {
        console.error('Erro ao carregar itens do participante:', error)
        throw error
      }
    },
    async storeNewItem ({ commit, state }, itemData) {
      try {
        const result = await storeItem(itemData)
        // Add new item to current items list
        if (result.data) {
          commit('addItem', result.data)
        }
        return result
      } catch (error) {
        console.error('Erro ao registrar item:', error)
        throw error
      }
    },
    async returnStoredItem ({ commit }, { id, notes }) {
      try {
        const result = await returnItem(id, notes)
        // Update item in current items list
        if (result.data) {
          commit('updateItem', result.data)
        }
        return result
      } catch (error) {
        console.error('Erro ao devolver item:', error)
        throw error
      }
    },
    async loadStats ({ commit }) {
      try {
        const stats = await fetchStats()
        commit('setStats', stats)
        return stats
      } catch (error) {
        console.error('Erro ao carregar estatísticas:', error)
        throw error
      }
    },
    clearCurrentParticipant ({ commit }) {
      commit('setCurrentParticipant', null)
      commit('setCurrentItems', [])
    }
  },
  getters: {
    activeLocations: state => state.locations.filter(l => l.is_active),
    activeItemTypes: state => state.itemTypes.filter(t => t.is_active),
    storedItemsCount: state => state.currentItems.filter(i => i.status === 'stored').length,
    returnedItemsCount: state => state.currentItems.filter(i => i.status === 'returned').length
  },
  mutations: {
    setLocations (state, locations) {
      state.locations = locations
      state.locationsLoaded = true
    },
    setItemTypes (state, itemTypes) {
      state.itemTypes = itemTypes
      state.itemTypesLoaded = true
    },
    setCurrentParticipant (state, participant) {
      state.currentParticipant = participant
    },
    setCurrentItems (state, items) {
      state.currentItems = items
    },
    addItem (state, item) {
      state.currentItems.unshift(item)
    },
    updateItem (state, updatedItem) {
      const index = state.currentItems.findIndex(i => i.id === updatedItem.id)
      if (index !== -1) {
        state.currentItems.splice(index, 1, updatedItem)
      }
    },
    setStats (state, stats) {
      state.stats = stats
    },
    resetCache (state) {
      state.locationsLoaded = false
      state.itemTypesLoaded = false
    }
  },
  namespaced: true
}
